const setInsuranceFor$ = 'directOrder/setInsuranceFor$';

const SET_INSURANCE_QUANTITY = 'directOrder/SET_INSURANCE_QUANTITY';

const CLEAN_INSURANCE = 'directOrder/CLEAN_INSURANCE';

export default {
  setInsuranceFor$,
  SET_INSURANCE_QUANTITY,
  CLEAN_INSURANCE,
};
